module.exports = __webpack_public_path__ + "img/teacher-home-quick3.0ec62585.png";